import { backend } from "src/api";

class NoticeApi {
  async getActiveNotices(target = "DASHBOARD") {
    const response = await backend.get("/notices/active", { params: { target } });
    return response.data;
  }
}

export const noticeApi = new NoticeApi();
